module.exports = __webpack_public_path__ + "img/team-photo.89a22313.webp";